<template>
  <section>
    <!--工具条-->
    <el-row class="Nbut" style="margin: 23px auto 0px 0px">
      <el-input
        v-model="name"
        placeholder="请输入内容"
        id="inputhieght"
        style="width: 210px; margin: 0px 20px 10px 15px; height: 30px"
        clearable
      ></el-input>
      <el-button
        type="primary"
        @click="OcliSigin"
        style="
          line-height: 0;
          width: 70px;
          height: 30px;
          background: #007aff;
          border-radius: 3px;
          margin-right: 20px;
        "
        >查询</el-button
      >
      <el-button
        type="primary"
        @click="onClickfatherDatas"
        style="
          line-height: 0;
          width: 118px;
          height: 30px;
          background:#007aff;
          border-radius: 3px;
          margin-right: 50px;
          float: right;
          text-align: center;
        "
        >返回上一页</el-button
      >
    </el-row>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '90px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column   type="selection" width="50" align="center"></el-table-column> -->
      <!-- <el-table-column type="index" width="60" align="center"></el-table-column> -->
      <el-table-column
        prop="CustomerName"
        label="家长姓名"

        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ContentUrl"
        label="状态"
        sortable
        align="center"
      >
        <template slot-scope="scope">
         {{scope.row.Status==1?"未读":"已读"}}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="CreateTime" label="操作" align="center" sortable>
        <template slot-scope="scope">
          
          <span class="SpanList" @click="Update(scope.row.Id)">编辑</span>
          <span class="SpanList" @click="Del(scope.row.Id)">删除</span>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页 -->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
      style="margin-top: 20px;"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="10"
        :total="total"
        style="text-align: center"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import { GetSchoolCustomerStatus } from "../../api/api";
export default {
  data() {
    return {
      IdentifierOne: null,
      Title: null,
      listLoading: false,
      page: 10,
      users:[],
      name:"",
      total:0
    };
  },
  async created() {
    this.IdentifierOne = this.$route.query.IdentifierOne;
    await this.GetSchoolCustomerStatus();
  },
  methods: {
       // 返回组列表
    onClickfatherDatas() {
      this.$router.push("/Hera_Popular/MessageNew");
      // this.$router.push({
      //   path: "/Course/courseData_index",
      //   query: { Id: id },
      // });
    },
    OcliSigin(){},
    //获取子目录列表
    async GetSchoolCustomerStatus() {
      this.listLoading = true;
      await GetSchoolCustomerStatus({
        PageIndex: this.page,
        IdentifierOne: this.IdentifierOne,
        Name: this.name,
      }).then((res) => {
        console.log(res);
         if (res.data.success) {
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
           this.users = [];
          this.total =0;
          this.listLoading = false;
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
  },
  mounted() {
    ///获取按钮控件
  },
};
</script>

<style scoped>
.eltable {
  border: 1px solid #dbf4ff;
}
.class_header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sex_header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.echarts_demo {
  width: 800px;
}
/* .Nbut {
  padding-bottom: 20px;
  border-bottom: 2px solid #606266;
} */
</style>